/**
 * @services/analytics — stable import path, now backed by the in-house Wisetap
 * ingest module (src/services/analytics/). Kept as a thin re-export so all
 * call sites stay unchanged.
 *
 * Public API is identical to the old CleverTap singleton (setUser /
 * trackScreen / trackFbGoogleEvents / trackEvent / trackEventCT), plus flush()
 * and reset(). The CleverTap SDK is fully removed; notification channels are
 * created natively in MainApplication.kt.
 *
 * NOTE: the target is "./analytics/index" (the directory), NOT "./analytics"
 * which would resolve back to this file (file-over-directory) and self-loop.
 */
export { default } from "./analytics/index";
